// extracted by mini-css-extract-plugin
module.exports = {"card":"_2b9e3ff1","container":"_8cb1b8ab","icon_link":"_c4891e9e","icon":"_757e1832","content":"_9e7ef53f","description":"_537bd8c9","hoverable":"_371765bc"};